import React from "react"

import "./Link.scss"

interface ILink {
  onClick?(): void
  href?: string
}

const Link: React.FC<React.PropsWithChildren<ILink>> = ({children, onClick, href}) => {
  const className = [
    "neo__Link"
  ].join(" ")

  return <a href={href} className={className} onClick={onClick}>{children}</a>
}

export default Link
